const useNewsCategory = () => {
  const drawerMenu = [];

  return {
    drawerMenu,
  };
};

export default useNewsCategory;
